/* import __COLOCATED_TEMPLATE__ from './rset-tempco.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();